var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHazAdaptAccountLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 148,
    viewBox: "0 0 80 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2515_1525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7196 1.93244C30.7196 0.865732 29.8576 0 28.7956 0H23.0236C21.9616 0 21.0996 0.865732 21.0996 1.93244V85.0272C21.0996 86.0939 21.9616 86.9597 23.0236 86.9597H28.7956C29.8576 86.9597 30.7196 86.0939 30.7196 85.0272",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7192 48.3109C30.7192 43.0257 38.7754 43.4798 40.3392 43.4798C41.9029 43.4798 49.9591 43.6436 49.9591 48.3109C49.9591 51.4225 49.9591 70.1027 49.9591 104.352C49.9591 105.418 50.8211 106.284 51.8831 106.284H57.6551C58.7172 106.284 59.5791 105.418 59.5791 104.352C59.5791 65.3875 59.5791 44.3219 59.5791 41.1546C59.5791 36.4037 44.9794 33.8176 40.3392 33.8176C30.7192 33.8048 25.9092 35.4151 25.9092 38.6487",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 78.6C4.2998 73.0772 8.77696 68.6 14.2998 68.6H39.9998V140H14.2998C8.77696 140 4.2998 135.523 4.2998 130V78.6Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 68.6H65.7C71.2228 68.6 75.7 73.0771 75.7 78.6V130C75.7 135.523 71.2228 140 65.7 140H40V68.6Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8902 103.826C37.0699 102.882 37.8946 102.2 38.8549 102.2H41.1449C42.1052 102.2 42.9299 102.882 43.1096 103.826L45.1477 114.526C45.3824 115.758 44.4376 116.9 43.183 116.9H36.8168C35.5622 116.9 34.6174 115.758 34.8521 114.526L36.8902 103.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.9998,
    cy: 98.7,
    r: 7.7,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2515_1525",
    x: 0.299805,
    y: 0,
    width: 79.4004,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2515_1525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2515_1525",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazAdaptAccountLock);
export default __webpack_public_path__ + "static/media/HazAdaptAccountLock.22140ac8aa223c8b9c8a80401fcc4193.svg";
export { ForwardRef as ReactComponent };